export const GIPHY_API_KEY = 'dc6zaTOxFJmzC'
export const urls = {
  giphySearch: 'https://api.giphy.com/v1/gifs/search',
  footerUrl: 'https://www.youtube.com/watch?v=ef0o5wN1GvQ' // Yellowman Can!
}
export const defalutQuery = 'surfing'



// WEBPACK FOOTER //
// ./src/constants/config.js